import { createContext, useState } from "react";

const TopBarContext = createContext();

const TopBarProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState({
    title: "",
    count: null,
  });

  return (
    <TopBarContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </TopBarContext.Provider>
  );
};

export { TopBarContext, TopBarProvider };
